import { ensurePlatformAccessTokenReady, getCurrentPlatformAccessToken } from '@auth/platformSession';
import { createWorkerAuthContext, createWorkerAuthRefreshResponse, isWorkerAuthRefreshRequest, WorkerAuthContext } from './workerAuth';

export function getCurrentWorkerAuthContext(): WorkerAuthContext {
    return createWorkerAuthContext(getCurrentPlatformAccessToken());
}

export function handleWorkerAuthRefreshMessage(worker: Worker, event: MessageEvent): boolean {
    if (!isWorkerAuthRefreshRequest(event.data)) {
        return false;
    }

    void ensurePlatformAccessTokenReady()
        .then((accessToken) => {
            worker.postMessage(createWorkerAuthRefreshResponse(event.data.requestId, createWorkerAuthContext(accessToken)));
        })
        .catch(() => {
            worker.postMessage(createWorkerAuthRefreshResponse(event.data.requestId, createWorkerAuthContext(null)));
        });

    return true;
}
